module.exports = __webpack_public_path__ + "img/elec_total.73e15790.png";